import { styled } from "@mui/material/styles";
import { FlexSideDrawer } from "designSystem/index";
import React, { useState } from "react";
import { grey } from "designSystem/styles/color";

const Drawer = styled("div")(({
	theme: Theme,
}) => ({
	backgroundColor: grey[200],
	height: "100%",
	paddingTop: 64,
}));

const DrawerClosed = styled("div")(({
	theme: Theme,
}) => ({
	backgroundColor: grey[500],
	height: "100%",
}));

const ViewDiv = styled("div")(({
	theme: Theme,
}) => ({
	backgroundColor: grey[700],
	height: "100%",
	padding: 64,
}));

export default () => {
	const [drawerOpen, setDrawerOpen] = useState(true);


	return (
		<FlexSideDrawer
			drawerNode={<Drawer>This is drawer Node</Drawer>}
			drawerNodeWhenClosed={<DrawerClosed />}
			onToggleOpen={setDrawerOpen}
			open={drawerOpen}
		>
			<ViewDiv>
				This is view viewNode
			</ViewDiv>
		</FlexSideDrawer>
	);
};